import React, { useState, useEffect } from 'react';
import MasterPage from 'components/MasterPage';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { CreditCardOutlined } from '@material-ui/icons';
import DatePicker from 'react-datepicker';
import { Currency, currencyReverse } from 'helpers/Currency';
import { api } from 'services';
// import CreditCardFormRevenues from './Revenues';
import Axios from 'axios';
import { parseDateBR } from 'helpers/date';
import { Link, useHistory } from 'react-router-dom';
import { DebounceInput } from 'react-debounce-input';
import BootstrapTable from 'react-bootstrap-table-next';
import { Trans } from 'react-i18next';
// import MyLoadStyle from './MyLoadStyle';
import Pagination from 'react-js-pagination';

const CreditCard = () => {
  const defaultFilters = {
    per_page: 10,
    page:1
  };
  const history = useHistory();
  
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState(defaultFilters);
  const [token_cancel_request, set_token_cancel_request] = useState(Axios.CancelToken.source());

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };
  const handlePageChange = (page) => handleFilterChange({ page });

  useEffect(() => {
    token_cancel_request.cancel('Não é mais de meu interesse enviar esta requisição.');
    let aux_token_cancel_request = Axios.CancelToken.source();
    set_token_cancel_request(aux_token_cancel_request);

    api.get(`/credit-card/`,{params:filters,cancelToken: aux_token_cancel_request.token})
      .then(({ data }) => {
        setData(data.data);
        setPagination(data.pagination);
      });
  }, [filters]);

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      headerStyle: {
        width: '10%',
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      }
    },
    {
      dataField: 'card_brand',
      text: 'Bandeira',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
    },
    {
      dataField: 'due_date',
      text: 'Data de Vencimento',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => parseDateBR(cell),
    },
    {
      dataField: 'value',
      text: 'Valor',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => parseFloat(cell).toLocaleString("pt-BR",{style:"currency",currency:"BRL"})
    },
    {
      dataField: 'total',
      text: 'Valor total de notas',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => parseFloat(cell).toLocaleString("pt-BR",{style:"currency",currency:"BRL"})
    },
    {
      dataField: 'is_close',
      text: 'Status',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => cell==1?'Fechado':'Aberto'
    },
    {
      dataField: 'id',
      text: '',
      headerStyle: {
        width: '5%',
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      formatter: (cell) => {
        return <Button size="sm" className="" variant="primary-login" as={Link} to={`/creditcard/form/${cell}`}>
         Ver
      </Button>
      }
    },
  ];

  return <>
    <Row>
      <Col className="d-flex mt-3 mb-3">
        <CreditCardOutlined className="icon-title" />
        <h4 className="title-dashboard mt-2">Cartão de Credito</h4>
      </Col>
    </Row>
    <Card.Body className="shadow bg-white rounded mb-3">
      <Row className="mb-3">
        <Col xs="auto">
          <Button size="sm" className="login-btn mr-1" variant="primary-login" as={Link} to="/creditcard/form">
            <i className="fas fa-plus"></i> Adicionar novo
          </Button>
        </Col>
      </Row>
      <Row className="justify-content-between">
        <Col xs="auto">
          <Form.Group>
            <Form.Label>Registros por página:</Form.Label>
            <Form.Control
              as="select"
              value={filters.per_page}
              onChange={(e) =>
                handleFilterChange({ per_page: e.target.value, page:1 })
              }
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md="3">
          <Form.Group>
            <Form.Label>Buscar:</Form.Label>
            <DebounceInput
              element={Form.Control}
              debounceTimeout={500}
              value={filters.__search}
              onChange={(e) =>
                handleFilterChange({ __search: e.target.value, page:1 })
              }
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <BootstrapTable
            responsive
            keyField="id"
            data={data}
            columns={columns}
            wrapperClasses="table-responsive table-mobile-transform"
            // rowStyle={ rowStyle }
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Trans i18nKey="label:interpolateShowingRecords">
            Showing {{ from: pagination.from || '0' }} to {{ to: pagination.to || '0' }}{' '}
            from {{ total: pagination.total }} records
          </Trans>
        </Col>
        <Col className="d-flex justify-content-end">
          <Pagination
            activePage={pagination.current_page}
            itemsCountPerPage={pagination.per_page}
            totalItemsCount={pagination.total}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            prevPageText="‹"
            nextPageText="›"
          />
        </Col>
      </Row>
    </Card.Body>

  </>;
}

export default MasterPage(CreditCard);